import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GaAskDialogComponent } from './ask-dialog.component';

@NgModule({
    declarations: [GaAskDialogComponent],
    entryComponents: [GaAskDialogComponent],
    exports: [GaAskDialogComponent],
    imports: [
        // Angular and vendors
        CommonModule,
        TranslateModule,
        MatButtonModule,
        MatDialogModule
    ]
})
export class GaAskDialogModule { }
